
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" allowClear  placeholder="搜索关键字"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="赛季赛区">
              <a-cascader :options="sjsqOptions" :fieldNames="{ label: 'name', value: 'id', children: 'children' }" placeholder="请选择赛区" v-model="queryParam.sjsq" changeOnSelect />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="状态">
              <a-select v-model="queryParam.memberstatus" placeholder="请选择"
                        allowClear >
                <a-select-option value="1">秩序册填写</a-select-option>
                <a-select-option value="2">项目填写</a-select-option>
                <a-select-option value="3">人员统计</a-select-option>
                <a-select-option value="4">住宿信息</a-select-option>
                <a-select-option value="5">等待付款</a-select-option>
                <a-select-option value="6">报名成功</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="省市">
                <a-cascader :options="areaOptions" placeholder="请选择地区" v-model="queryParam.namekeys" changeOnSelect
                />
              </a-form-item>
            </a-col>
          </a-col>

           </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" >
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator" >

      <a-button @click="download(1)" style="margin-left: 8px"  >
        随队裁判名称 <a-icon type="download" />
      </a-button>

      <a-button @click="download(2)" style="margin-left: 8px"  >
        单位联系人导出 <a-icon type="download" />
      </a-button>

      <a-button @click="download(3)" style="margin-left: 8px"  >
        参赛人员身份证统计 <a-icon type="download" />
      </a-button>

      <a-button @click="download(4)" style="margin-left: 8px"  >
        参赛人数统计 <a-icon type="download" />
      </a-button>

      <a-button @click="download(5)" style="margin-left: 8px"  >
        秩序信息表 <a-icon type="download" />
      </a-button>

      <a-button @click="download(6)" style="margin-left: 8px"  >
        缴费信息表 <a-icon type="download" />
      </a-button>

    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <span slot="danwei" slot-scope="text,record">
          <div style="margin-left: 10px; float: left">
            {{record.danwei}}
            <br/><span style="color: #999">{{record.mingcheng}}</span>
            <br/>
            {{record.create_time|timeFormat}}
            <br/>
          </div>
      </span>
      <span slot="saiqu" slot-scope="text,record">
        {{record.saiqu_name}}
      </span>
      <span slot="status" slot-scope="text,record">
        <a-tag v-if="record.memberstatus==1" >秩序册填写</a-tag>
        <a-tag v-if="record.memberstatus==2" >项目填写</a-tag>
        <a-tag v-if="record.memberstatus==3" >人员统计</a-tag>
        <a-tag v-if="record.memberstatus==4" >住宿信息</a-tag>
        <a-tag v-if="record.memberstatus==5" color="red">等待付款</a-tag>
        <a-tag v-else-if="record.memberstatus==6" color="green">报名成功</a-tag>
      </span>
      <span slot="action" slot-scope="text,record">
        <template >
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="handleOrderEdit(record)">缴费信息</a>
          <a-divider type="vertical" />
          <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="applyDelete(record)"  okText="确定" cancelText="取消">
            <a href="javascript:;">删除</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>



    <a-modal
            title="操作"
            :width="1200"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="visible"
            @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form" >
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="单位"
                  hasFeedback
            >
            <a-input v-model="formData.danwei"
                     placeholder="请输入单位名称"/>
          </a-form-item>
              </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="队伍名称"
                      :extra="'全称是 '+formData.danwei+formData.mingcheng+'啦啦队'"
                      hasFeedback
              >
                <a-input v-model="formData.mingcheng"
                          placeholder="请输入队伍名称"/>
              </a-form-item>

              </a-col>
            </a-row>
          <a-row :gutter="48">

            <a-col :md="12" :sm="24">
              <a-form-item
                      label="队伍照片"
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
              >
                <pic-uploader
                        :numberLimit="1"
                        :file-list="formData.heying"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">


              </a-col>
            </a-row>

          <a-row>

            <a-col :md="48" :sm="24">
              <a-form-item
                      :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                      :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                      label="报名状态"
                      hasFeedback
              >
              <a-radio-group v-model="formData.memberstatus" button-style="solid">
                <a-radio-button :value="1">
                  秩序册填写
                </a-radio-button>
                <a-radio-button :value="2">
                  项目填写
                </a-radio-button>
                <a-radio-button :value="3">
                  人员统计
                </a-radio-button>
                <a-radio-button :value="4">
                  住宿信息
                </a-radio-button>
                <a-radio-button :value="5" :disabled="formData.memberstatus==1">
                  等待付款
                </a-radio-button>
                <a-radio-button :value="6" :disabled="formData.memberstatus==1">
                  报名成功
                </a-radio-button>
              </a-radio-group>

            </a-form-item>
              </a-col>
          </a-row>

          <a-divider>领队/联系人信息</a-divider>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="领队姓名"
                      hasFeedback
              >
                <a-input  v-decorator="[
          'ldname',
          {rules: [{ required: true, message: '请输入领队姓名' }]}
        ]"
                          placeholder="请输入领队姓名"/>
              </a-form-item>

            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="证件类型"
                      hasFeedback
              >

                <a-select v-model="formData.ldcardtype" placeholder="请选择"  >
                  <a-select-option :value="1">身份证</a-select-option>
                  <a-select-option :value="2">护照</a-select-option>
                </a-select>

              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="证件号码"
                      hasFeedback
              >
                <a-input  v-decorator="[
          'ldnum',
          {rules: [{ required: true, message: '请输入证件号码' }]}
        ]"
                          placeholder="请输入证件号码"/>
              </a-form-item>
            </a-col>


            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="领队性别"
                      hasFeedback
              >

                <a-select v-model="formData.ldsex" placeholder="请选择"  >
                  <a-select-option :value="1">男</a-select-option>
                  <a-select-option :value="2">女</a-select-option>
                </a-select>

              </a-form-item>
            </a-col>


            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="领队手机"
                      hasFeedback
              >
                <a-input  v-decorator="[
          'phone',
          {rules: [{ required: true, message: '请输入手机' }]}
        ]"
                          placeholder="请输入手机"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="联系人"
                      hasFeedback
              >
                <a-input  v-decorator="[
          'lxname',
          {rules: [{ required: true, message: '请输入QQ' }]}
        ]"
                          placeholder="请输入QQ"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="联系人手机"
                      hasFeedback
              >
                <a-input  v-decorator="[
          'lxphone',
          {rules: [{ required: true, message: '请输入手机' }]}
        ]"
                          placeholder="请输入手机"/>
              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="裁判"
                      hasFeedback
              >

                <div v-for="(user,index) in formData.caipan" :key="index" >
                  <a-tag >{{user.name}} ({{user.num}})</a-tag>
                  <a-icon type="close-circle" @click="caipanRemove(index)" />
                </div>

                <a @click="caipanPickerShow = true" v-show="!caipanPickerShow" href="#nogo">新增</a>
                <caipan-picker style="width: 300px; margin-right: 10px;"   :user_id="formData.user_id" :danwei_id="formData.danwei_id" @onSelect="onCaipanAdd" v-show="caipanPickerShow" />
                <a @click="caipanPickerShow = false" v-show="caipanPickerShow" href="#nogo">取消</a>

              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="教练"
                      hasFeedback
              >
                <div v-for="(user,index) in formData.jiaolian" :key="index" >
                  <a-tag >{{user.name}} ({{user.num}})</a-tag>
                  <a-icon type="close-circle" @click="jiaolianRemove(index)" />
                </div>

                <a @click="jiaolianPickerShow = true" v-show="!jiaolianPickerShow" href="#nogo">新增</a>
                <jiaolian-picker style="width: 300px; margin-right: 10px;"  :user_id="formData.user_id" :danwei_id="formData.danwei_id" @onSelect="onJiaolianAdd" v-show="jiaolianPickerShow" />
                <a @click="jiaolianPickerShow = false" v-show="jiaolianPickerShow" href="#nogo">取消</a>
              </a-form-item>
            </a-col>
          </a-row>

          <a-divider>项目信息</a-divider>

          <a-table :columns="subjectColumns" :data-source="formData.subjectlist" :pagination="false">
            <p slot="expandedRowRender" slot-scope="record" style="margin: 0">
              运动员:
              <a-tag v-for="(user,index) in record.yundongyuan" :key="index">{{user.name}}</a-tag>
              <br/>
              替补运动员:
              <a-tag v-for="(user,index) in record.tbydy" :key="index">{{user.name}}</a-tag>
              <br/>
              教练:
              <a-tag v-for="(user,index) in record.jiaolian" :key="index">{{user.name}}</a-tag>
              <br/>
            </p>
          </a-table>

          <a-divider>操作日志</a-divider>
          <a-timeline>
            <a-timeline-item v-for="log in formData.loglist" :key="log.id">
              {{log.create_time|timeFormat}}
              <b>{{log.user_name}}</b>
              {{log.title}}
              <span v-if="log.note" class="gray">备注:{{log.note}}</span>
            </a-timeline-item>
          </a-timeline>
        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>




    <a-modal
            title="操作"
            :width="1200"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="orderVisible"
            @ok="handleOrderOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form" >
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="单位"
                      hasFeedback
              >
                {{orderFormData.danwei}}
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="队伍名称"
                      hasFeedback
              >
                {{orderFormData.mingcheng}}
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="赛事服务费"
                      hasFeedback
              >
                <a-input v-model="orderFormData.memberprice" allowClear  placeholder="赛事服务费"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="应付"
                      hasFeedback
              >
                <a-input v-model="orderFormData.pay_price" allowClear  placeholder="应付金额"/>
              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="线上实付"
                      hasFeedback
              >
                {{orderFormData.payed_price}}
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="线上支付时间"
                      hasFeedback
              >
                {{orderFormData.pay_time_str}}
              </a-form-item>
            </a-col>
          </a-row>

          <a-row>
          <a-col :md="48" :sm="24">
              <a-form-item
                      :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                      :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                      label="支付状态"
                      hasFeedback
              >
                <a-radio-group v-model="orderFormData.status" button-style="solid">
                  <a-radio-button :value="1">
                    未支付
                  </a-radio-button>
                  <a-radio-button :value="2">
                    支付成功
                  </a-radio-button>
                </a-radio-group>

              </a-form-item>
            </a-col>
          </a-row>


          <a-row>
            <a-col :md="48" :sm="24">
              <a-form-item
                      :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                      :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                      label="管理员备注"
                      hasFeedback
              >
                <a-textarea v-model="orderFormData.adminnote" placeholder="" auto-size />
              </a-form-item>
            </a-col>
          </a-row>

        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleOrderCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOrderOk">保存</a-button>
      </template>
    </a-modal>




  </a-card>
  </template>

  <script>
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import EditableCell from '@/components/EditableCell/'
  import PicUploader from '@/components/PicUploader/'
  import FileUploader from '@/components/FileUploader/'
  import JiaolianPicker from '@/components/JiaolianPicker/'
  import CaipanPicker from '@/components/CaipanPicker/'
  import areaOptions from '@/utils/area'
  import moment from 'moment'
  import setting from '@/config/setting'
  import 'moment/locale/zh-cn';
  moment.locale('zh-cn');

  import { getApplyList ,getApplyDetail,editApply ,applyDelete ,sjsqOptions ,getApplyOrderDetail ,editApplyOrder} from '@/api/sai'
  export default {
    name: 'KaojiApplyList',
    components: {
      AInput,
      ATextarea,
      FileUploader,
      PicUploader,
      STable,
      EditableCell,
      CaipanPicker,
      JiaolianPicker,
    },
    data () {
      return {
        areaOptions,
        visible: false,
        orderVisible: false,
        saveLoading:false,
        jiaolianPickerShow:false,
        caipanPickerShow:false,
        sjsqOptions:[],
        orderFormData:{

        },
        formData:{
          id:0,
          danwei:'',
          mingcheng:'',
          datetitle_moment:null,
          datetitle:'',
          heying:[],
          jiaolian:[],
          caipan:[],
          subjectlist:[],
          loglist:[],
        },
        time_range_moment:[],
        time_range:[],
        labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        mdl: {},

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
          keywords:'',
          sjsq:[]
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '50px'
          },
          {
            title: '报名信息',
            dataIndex: 'danwei',
            scopedSlots: { customRender: 'danwei' },
          },
          {
            title: '赛区',
            dataIndex: 'saiqu',
            scopedSlots: { customRender: 'saiqu' +
            '' },
          },
          {
            title: '进度',
            dataIndex: 'status',
            scopedSlots: { customRender: 'status' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            fixed: 'right',
            width: 220,
            scopedSlots: { customRender: 'action' },
          }
        ],
        // 表头
        subjectColumns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '50px'
          },
          {
            title: '项目信息',
            dataIndex: 'subject_name',
          },
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          console.log('loadData');
          console.log(this.queryParam);
          let that= this;

          if (this.time_range_moment[0] && this.time_range_moment[1]) {
            this.queryParam.time_range = [
              this.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),
              this.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')
            ]
          } else {
            this.queryParam.time_range = []
          }

          this.queryParam = Object.assign(this.queryParam,parameter);
          return getApplyList(this.queryParam)
            .then(res => {
              console.log('res');
              return res.data
            })
        },

        selectedRowKeys: [],
        selectedRows: [],
        cashFormData:{
          ids:[],
          to_type:'',
          price:0,
          note:'',
          count:0,
        }
      }
    },
    computed:{
    },
    created(){
    },

    mounted(){
      let that = this;
      that.getSjsqOptions();
    },
    methods: {
      moment,
      getSjsqOptions(){
        let that = this;
        sjsqOptions({}).then(res =>{
          that.sjsqOptions = res.data;
        });
      },
      handleCancel(){
        this.visible = false
      },
      handleOrderCancel(){
        this.orderVisible = false
      },
      //展开关闭
      toggleAdvanced() {
        this.advanced = !this.advanced
      },

      jiaolianRemove(index){
        console.log('jiaolianRemove',index);
        this.formData.jiaolian.splice(index,1);
        this.jiaolianPickerShow = false;
      },
      onJiaolianAdd(value){
        console.log('onJiaolianAdd',value);
        let exist = this.formData.jiaolian.filter(item =>{
          return item.num == value.num
        });
        if(exist.length >0){
          this.jiaolianPickerShow = false;
          return ;
        }
        this.formData.jiaolian.push(value);
        this.jiaolianPickerShow = false;
      },
      caipanRemove(index){
        console.log('caipanRemove',index);
        this.formData.caipan.splice(index,1);
        this.caipanPickerShow = false;
      },
      onCaipanAdd(value){
        console.log('onCaipanAdd',value);
        let exist = this.formData.caipan.filter(item =>{
          return item.num == value.num
        });
        if(exist.length >0){
          this.caipanPickerShow = false;
          return ;
        }
        this.formData.caipan.push(value);
        this.caipanPickerShow = false;
      },


      handleEdit(record){
        let self = this
        this.visible = true
        getApplyDetail({ id: record.id }).then(res => {
          setTimeout(() =>{
            self.form.setFieldsValue({ ...res.data })
            self.formData.id = record.id;
            console.log('handleEdit')
            self.formData = { ...res.data };
          },200)
        })
        // console.log(this.mdl)
      },
      handleOrderEdit(record){
        let self = this
        getApplyOrderDetail({ baoming_id: record.id }).then(res => {
          self.orderVisible = true
          setTimeout(() =>{
            self.orderFormData.id = record.id;
            console.log('handleEdit')
            self.orderFormData = { ...res.data };
          },200)
        }).catch(err =>{
          self.$message.error(err.data.msg);
        })
        // console.log(this.mdl)
      },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false)
    },

      // 增改 处理
      handleOk(e) {
        let self = this;
        e.preventDefault()
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.formData)
            self.saveLoading = true;
            editApply({
              id:self.formData.id,
              mingcheng:self.formData.mingcheng,
              danwei:self.formData.danwei,
              heying:self.formData.heying,
              ldcardtype:self.formData.ldcardtype,
              ldsex:self.formData.ldsex,
              ldname:values.ldname,
              ldnum:values.ldnum,
              phone:values.phone,
              lxname:values.lxname,
              lxphone:values.lxphone,
              memberstatus:self.formData.memberstatus,
              jiaolian:self.formData.jiaolian,
              caipan:self.formData.caipan,
            }).then(res => {
              self.$message.success('修改成功')
              self.$refs.table.refresh(false)
              self.visible = false;
              self.saveLoading = false;
            }).catch(err =>{
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }
        })
      },
      // 增改 处理
      handleOrderOk(e) {
        let self = this;
        e.preventDefault();

        self.saveLoading = true;
        editApplyOrder({
          id:self.orderFormData.id,
          baoming_id:self.orderFormData.baoming_id,
          status:self.orderFormData.status,
          adminnote:self.orderFormData.adminnote,
          memberprice:self.orderFormData.memberprice,
          pay_price:self.orderFormData.pay_price,
        }).then(res => {
          self.$message.success('修改成功')
          self.$refs.table.refresh(false)
          self.orderVisible = false;
          self.saveLoading = false;
        }).catch(err =>{
          self.$message.error(err.data.msg);
          self.saveLoading = false;
        })
      },

      // 删
      applyDelete(record) {
        let self = this
        applyDelete({ id: record.id }).then(res => {
          self.$message.success('删除成功')
          self.$refs.table.refresh(false)
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },



      download(type){
        console.log('this.queryParam')
        console.log(this.queryParam)
        if(typeof this.queryParam.sjsq == 'undefined' || this.queryParam.sjsq.length !=2){
          this.$message.error('请先选择赛区');
          return ;
        }
        switch (type){
          case 1:
            window.open(setting.apiBaseURL+'/adminapi/sai/caipanDownload?saiqu='+this.queryParam.sjsq[1]);
            break;
          case 2:
            window.open(setting.apiBaseURL+'/adminapi/sai/lianxirenDownload?saiqu='+this.queryParam.sjsq[1]);
            break;
          case 3:
            window.open(setting.apiBaseURL+'/adminapi/sai/rysfzDownload?saiqu='+this.queryParam.sjsq[1]);
            break;
          case 4:
            window.open(setting.apiBaseURL+'/adminapi/sai/csrstjDownload?saiqu='+this.queryParam.sjsq[1]);
            break;
          case 5:
            window.open(setting.apiBaseURL+'/adminapi/sai/zhixuceDownload?saiqu='+this.queryParam.sjsq[1]+'&memberstatus='+(this.queryParam.memberstatus||0));
            break;
          case 6:
            window.open(setting.apiBaseURL+'/adminapi/sai/caiwuDownload?saiqu='+this.queryParam.sjsq[1]);
            break;

        }
      },
    onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },

    },
    filters:{
    },
    watch: {
    }
  }
</script>
